import React, { memo } from 'react'
import { faArrowUpRightFromSquare } from '@fortawesome/pro-duotone-svg-icons'
import { Stack } from '@mui/material'

import OutsideLink from './OutsideLink'
import FaIcon from '../faIcon/FaIcon'

const LearnMoreLink = ({ to, label }) => {
  return (
    <OutsideLink
      label={
        <Stack direction='row' spacing={1} alignItems='center'>
          {label}
          <FaIcon icon={faArrowUpRightFromSquare} />
        </Stack>
      }
      to={to}
      color='text.primary'
      variant='body1'
    />
  )
}

export default memo(LearnMoreLink)
